import { render, staticRenderFns } from "./brand-ex-module2.vue?vue&type=template&id=61a311f9&scoped=true&"
import script from "./brand-ex-module2.vue?vue&type=script&lang=js&"
export * from "./brand-ex-module2.vue?vue&type=script&lang=js&"
import style0 from "./brand-ex-module2.vue?vue&type=style&index=0&id=61a311f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a311f9",
  null
  
)

export default component.exports